<template>
  <v-dialog v-model="value" persistent scrollable>
    <v-card>
      <div class="text-xs-right">
        <v-btn fab flat @click="onClose" small>
          <v-icon>close</v-icon>
        </v-btn>
        <v-divider></v-divider>
      </div>
      <v-card-text class="ma-0" style="height: 600px">
        <div class="text-xs-center">
          <v-pagination
            v-model="pageNumber"
            :length="pageCount"
            @input="onClickPageinate"
            class="mb-2"
          ></v-pagination>
        </div>
        <div style="min-height: 400px" v-if="loadingProduct || loading">
          <v-layout style="height: 400px" justify-center align-center row>
            <v-flex class="text-xs-center">
              <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
            </v-flex>
          </v-layout>
        </div>
        <template v-else>
          <v-container>
            <v-layout wrap>
              <template v-for="(product, index) in filterProducts">
                <v-flex xs6 sm3 xl2 class="pa-1" :key="product.id">
                  <sort-product-item v-model="filterProducts[index]" :key="'product_' + product.id">
                    <move-vertical
                      slot="move"
                      :index="(pageNumber - 1) * size + index"
                      :max="products.length"
                      @onMove="onMove(product.id, $event)"
                      :showForward="true"
                    ></move-vertical>
                  </sort-product-item>
                </v-flex>
              </template>
            </v-layout>
          </v-container>
        </template>

        <div class="text-xs-center">
          <v-pagination
            v-model="pageNumber"
            :length="pageCount"
            @input="onClickPageinate"
            class="mb-2"
          ></v-pagination>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import SortProductItem from './SortProductItem'
import MoveVertical from '@/components/elements/MoveVertical2'
import api from '@/api'
import { PAGE } from '@/constants/page.js'

export default {
  props: ['value', 'powerbuyFilterBranch'],
  data() {
    return {
      showSortProduct: this.value,
      sortproducts: [],
      loading: true,
      isNoSort: false,
      isChange: false,
      pageNumber: 1,
      size: 10,
      productCount: 0,
      loadingKFCProduct: true
    }
  },
  components: {
    SortProductItem,
    MoveVertical
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    products() {
      if (
        ['106855151601601', '102052945584054', '177518292310976'].includes(this.selectedBot.pageid)
      ) {
        return this.sortproducts
      } else {
        return this.$store.getters.getProducts
      }
    },
    loadingProduct() {
      if (
        ['106855151601601', '102052945584054', '177518292310976'].includes(this.selectedBot.pageid)
      ) {
        return this.loadingKFCProduct
      } else {
        return this.$store.getters.loadingProduct
      }
    },
    filterProducts() {
      const start = (this.pageNumber - 1) * this.size
      const end = start + this.size
      return this.sortproducts.slice(start, end)
    },
    pageCount: function () {
      let l = this.productCount
      let s = this.size
      return Math.ceil(l / s)
    }
  },
  async mounted() {
    this.isNoSort = false
    let products = []
    if (
      ['106855151601601', '102052945584054', '177518292310976'].includes(this.selectedBot.pageid)
    ) {
      this.loadingKFCProduct = true
      products = await this.getProductsKFC({
        limit: 1000,
        offset: 0
      })
      this.loadingKFCProduct = false
    } else {
      await this.$store.dispatch('loadProducts')
      products = this.products
    }
    this.sortproducts = products
    this.productCount = this.sortproducts.length
    this.sortproducts.map((product, index) => {
      if (product.priority == 0) this.isNoSort = true
      this.$set(this.sortproducts[index], 'priority', index + 1)
    })
    if (this.isNoSort) {
      this.checkMove(true)
    }
    this.loading = false
  },
  methods: {
    getProductsKFC(options) {
      let vm = this
      return new Promise((resolve, reject) => {
        let data = {
          pageid: vm.selectedBot.pageid,
          ...options
        }
        api.getProductsKFC(data, function (error, response) {
          if (error) {
            console.error(error)
            reject(error)
            return
          }
          resolve(response.data)
        })
      })
    },
    onClickPageinate: function (pageNum) {
      this.pageNumber = pageNum
      $('html, body').animate({
        scrollTop: 0
      })
    },
    onClose() {
      if (this.isChange) this.$emit('onChangeProduct')
      this.showSortProduct = false
      this.$emit('input', false)
    },
    onMove(id, direction) {
      var vm = this
      var index = vm.sortproducts.findIndex((el) => {
        return el.id == id
      })
      if (index != -1) {
        if (direction == 'up') {
          vm.sortproducts.splice(index, 0, vm.sortproducts.splice(index - 1, 1)[0])
          this.checkMove(false, [index, index - 1])
        } else if (direction == 'down') {
          vm.sortproducts.splice(index, 0, vm.sortproducts.splice(index + 1, 1)[0])
          this.checkMove(false, [index, index + 1])
        } else if (direction == 'top') {
          let product = vm.sortproducts.splice(index, 1)[0]
          vm.sortproducts.unshift(product)
          let listindex = []
          for (let c = 0; c <= index; c++) {
            listindex.push(c)
          }
          this.checkMove(false, listindex)
        } else if (direction == 'bottom') {
          let product = vm.sortproducts.splice(index, 1)[0]
          vm.sortproducts.push(product)
          let listindex = []
          for (let c = index; c < vm.sortproducts.length; c++) {
            listindex.push(c)
          }
          this.checkMove(false, listindex)
        }
      } else {
      }
    },
    checkMove: function (isAll, list) {
      // e.newIndex
      // e.oldIndex
      let vm = this
      let input = []
      if (isAll) {
        input = vm.sortproducts.map((el, index) => {
          return { id: el.id, priority: index + 1 }
        })
      } else {
        let priority = vm.sortproducts.map((el, index) => {
          return { id: el.id, priority: index + 1 }
        })

        input = priority.filter((el, index) => {
          return list.includes(index)
        })
      }

      if (input.length > 0) {
        let api_name = 'putpriorityproducts'
        if (
          this.selectedBot.pageid == '106855151601601' ||
          this.selectedBot.pageid == '102052945584054'
        ) {
          api_name = 'putpriorityproductskfc'
        }

        let data = { input, pageid: this.selectedBot.pageid }

        if (['powerbuy'].includes(this.selectedBot.theme) && this.powerbuyFilterBranch) {
          Object.assign(data, { shop_main_pageid: this.powerbuyFilterBranch.shop_main_pageid })
        }

        api[api_name](data, function (error, response) {
          if (error) {
            console.error(error)
            vm.isLoading = false
            return
          }
          vm.isChange = true
        })
      }
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      if (!newVal && oldVal) this.isChange = false
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/SortProduct.vue